import { apiService } from '@shared/services/apiServices';
import type {
  ListTechniciansResponse,
  ListTechniciansParams,
} from '@epics/technicianManagement/types/technicianListType';
import technicianEndpoints from './technicianEndpoints';

export const listTechnicianApiService = {
  listTechnicians: async (
    params?: ListTechniciansParams
  ): Promise<ListTechniciansResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.search) {
      queryParams.append('search', params.search);
    }
    if (params?.status) {
      queryParams.append('status', params.status);
    }
    if (params?.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString());
    }

    const endpoint = `${technicianEndpoints.TECHNICIANS}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiService.getAPI(endpoint, {
      skipGlobalErrorRedirect: true,
    });

    if (response.error) {
      if (response.status === 403) {
        const err = new Error('Forbidden') as Error & { status: number };
        err.status = 403;
        throw err;
      }
      return {
        data: [],
        totalCount: 0,
        page: params?.page || 1,
        limit: params?.limit || 10,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
      };
    }

    return response.data as ListTechniciansResponse;
  },
};
